"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var lodash_1 = require("lodash");
var subscriptions_transport_ws_1 = require("subscriptions-transport-ws");
var AWSSubscriptionClient = /** @class */ (function (_super) {
    __extends(AWSSubscriptionClient, _super);
    function AWSSubscriptionClient(url, options, webSocketImpl, webSocketProtocols) {
        var _this = _super.call(this, url, options, webSocketImpl, webSocketProtocols) || this;
        // since we are in TS and these functions are private we cannot directly override
        // in this child class so we use this trick (which is not safe) to override
        // the parent functions
        _this['flushUnsentMessagesQueue'] = _this.flush;
        _this['processReceivedData'] = _this.process;
        return _this;
    }
    AWSSubscriptionClient.prototype.setUrl = function (url) {
        _super.prototype['url'] = url;
    };
    AWSSubscriptionClient.prototype.getUnsentMessagesQueue = function () {
        return this['unsentMessagesQueue'] || [];
    };
    AWSSubscriptionClient.prototype.setUnsentMessagesQueue = function (queue) {
        this['unsentMessagesQueue'] = queue;
    };
    AWSSubscriptionClient.prototype.flush = function () {
        var _this = this;
        var messages = lodash_1.uniqBy(this.getUnsentMessagesQueue(), 'id');
        messages.forEach(function (message) {
            _super.prototype['sendMessageRaw'].call(_this, message);
        });
    };
    AWSSubscriptionClient.prototype.process = function (receivedData) {
        try {
            var message_1 = JSON.parse(receivedData);
            // ignore start_ack message from appsync since this isn't
            // treated as a valid gql message type
            if (message_1.type === 'start_ack') {
                var newQueue = this.getUnsentMessagesQueue().filter(function (el) { return el.id !== message_1.id; });
                this['setUnsentMessagesQueue'](newQueue);
                return;
            }
            _super.prototype['processReceivedData'].call(this, receivedData);
        }
        catch (err) {
            // do nothing
        }
    };
    return AWSSubscriptionClient;
}(subscriptions_transport_ws_1.SubscriptionClient));
exports.AWSSubscriptionClient = AWSSubscriptionClient;
